import { isProductionEnvironment } from './util';

export function openHSiFrame(client, url, onDelete, onNext) {
  client.once('cancel', () => {
    // Delete the template in our system if they cancel when making a new one
    if (onDelete) {
      onDelete();
    }
  });

  client.once('finish', onNext);

  client.open(url, {
    testMode: isProductionEnvironment() ? false : true,
    skip_signer_roles: 1,
    container: document.getElementById('hellosign-iframe-entry'),
    whiteLabeling: {
      primary_button_color: '#00b88d',
    },
  });
}
